export default __webpack_public_path__ + "static/media/ProfileImagePlaceHolder.cd22436e.png";